import store from 'store2'

const TokenKey = 'Admin-Token'

/** Reject empty / literal "null" / "undefined" from hash redirects */
export function isValidAccessToken(token) {
  if (token == null) return false
  const t = String(token).trim()
  return t !== '' && t.toLowerCase() !== 'null' && t.toLowerCase() !== 'undefined'
}

export function getToken() {
  const token = store.get(TokenKey)
  return isValidAccessToken(token) ? token : ''
}

export function setToken(token) {
  if (!isValidAccessToken(token)) {
    return store.remove(TokenKey)
  }
  return store.set(TokenKey, token)
}

export function removeToken() {
  return store.remove(TokenKey)
}
